@if (invoice(); as invoice) {
  @let totalDue = invoice.amount - invoice.receivedAmount;
  <!-- Mobile -->
  <div class="flex md:hidden flex-col grow gap-[14px] w-full p-5 bg-[#0f3d3b] relative">
    <button type="button"
            class="absolute top-[14px] right-[14px] size-8 rounded-full bg-white/[0.16] border-none cursor-pointer flex items-center justify-center transition-colors hover:bg-white/[0.26]"
            (click)="matDialogRef.close({ action: 'toast', source: 'button' })">
      <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-white"></mat-icon>
    </button>
    <header class="flex items-center justify-between w-full">
      <h2 class="!m-0 !text-[18px] !font-semibold text-white !leading-tight">Invoice</h2>
    </header>

    <div class="flex items-center justify-between w-full">
      <span class="text-[12px] font-normal text-[#a1c4c7]">Status</span>
      <span class="flex items-center gap-[6px]">
        <span class="size-[7px] rounded-full bg-[#bf730f]"></span>
        <span class="text-[12px] font-semibold text-[#bf730f]">Pending payment</span>
      </span>
    </div>
    <div class="flex items-start justify-between w-full">
      <span class="text-[12px] font-normal text-[#a1c4c7] whitespace-nowrap">Invoice ID</span>
      <span class="text-[12px] font-medium text-white text-right flex items-center gap-2" [appCopyToClipboardCopied]="invoice.uuid">
        <span>{{ invoice.uuid | cropWithDotsCenter }}</span>
        <mat-icon [class]="'text-white !w-[12px] !h-[12px] !text-[12px]'" svgIcon="copy-icon"></mat-icon>
      </span>
    </div>
    <div class="flex items-start justify-between w-full">
      <span class="text-[12px] font-normal text-[#a1c4c7]">Date</span>
      <span class="text-[12px] font-medium text-white">{{ invoice.issueDate | date:'dd.MM.yyyy' }}</span>
    </div>

    <div class="flex flex-col items-center gap-[10px] w-full p-4 rounded-[14px] bg-white/[0.06] border border-white/[0.12]">
      <div class="flex items-start gap-[6px] w-full">
        <button type="button"
                class="flex-1 h-7 px-2 py-[6px] rounded-md text-[11px] font-semibold transition-colors border-none"
                [ngClass]="network() === 'TRC-20' ? 'bg-[#022d35] text-white' : 'bg-white/[0.06] text-[#a1c4c7]'"
                >USDT TRC-20</button>
        <button type="button"
                class="flex-1 h-7 px-2 py-[6px] rounded-md text-[11px] font-semibold transition-colors cursor-default border-none" [disabled]="true"
                [ngClass]="network() === 'ERC-20' ? 'bg-[#022d35] text-white' : 'bg-white/[0.06] text-[#a1c4c7]'"
                >USDT ERC-20</button>
      </div>

      <div class="flex items-center gap-2 w-full px-[10px] py-2 rounded-md bg-white/[0.06]" [appCopyToClipboardCopied]="invoice.depositAddress">
        <span class="flex-1 min-w-0 text-[11px] font-medium text-white break-all">{{ invoice.depositAddress }}</span>
        <button type="button" class="shrink-0 size-[22px] bg-white/[0.08] border-none rounded text-white cursor-pointer transition-colors hover:bg-white/[0.18]">
          <mat-icon svgIcon="copy-clipboard-new" class="!w-full !h-auto max-w-[10px] max-h-[10px]"></mat-icon>
        </button>
      </div>

      <div class="flex items-center justify-center size-[140px] rounded-[12px] bg-white p-2">
        <ng-container *ngTemplateOutlet="qrSvg"></ng-container>
      </div>

      <p class="!m-0 text-[11px] font-semibold text-[#bf730f] flex gap-[5px] items-center">
        <mat-icon svgIcon="warning" class="!w-3 !h-3 text-[#bf730f]"></mat-icon>
        QR for USDT {{ network() }} only
      </p>
      <p class="!m-0 text-[12px] font-normal text-[#a1c4c7] text-center leading-[1.45]">Please be advised that the minimum balance top-up amount is {{ minBalance() | number:('1.2-2') }} USDT</p>
      @if (invoice.transactions.length > 0) {
        <span class="flex text-white text-[14px] leading-[1.2] mb-[2px] w-full shrink-0 mt-[10px]">USDT TRC20 transactions:</span>
        <ul class="m-0 w-full flex flex-col max-h-[120px] overflow-y-auto overflow-x-hidden pr-[10px]">
          @for (transaction of invoice.transactions; track transaction.transactionHash) {
            <li class="flex items-center justify-between gap-3 w-full py-2 shrink-0 [&:not(:first-child)]:border-t [&:not(:first-child)]:border-solid [&:not(:first-child)]:border-white/10">
              <span class="text-white text-[12px] leading-[1.2] font-medium shrink-0">{{ transaction.amount | number:'1.2-2' }} USDT</span>
              <span [appCopyToClipboardCopied]="transaction.transactionHash"
                    class="min-w-0 flex items-center gap-1">
                  <span class="text-[#FFCB10] text-[12px] leading-[1.2] font-medium">
                    {{ transaction.transactionHash | cropWithDotsCenter:10:10 }}
                  </span>
                  <mat-icon svgIcon="copy-clipboard-new" class="text-white !w-full !h-auto max-w-[10px] max-h-[10px]"></mat-icon>
                </span>
            </li>
          }
        </ul>
      }
    </div>

    <div class="h-px w-full bg-white/[0.12]"></div>

    <div class="flex items-start justify-between w-full">
      <div class="flex flex-col gap-[2px]">
        <p class="!m-0 text-[14px] text-white font-semibold">{{ invoice.userPlan?.userPlanType | titlecase }} Plan · {{ invoice.userPlan?.billingCycle === 'YEARLY' ? 'Annual' : 'Monthly' }}</p>
        <p class="!m-0 text-[11px] font-normal text-[#a1c4c7]">{{ invoice.userPlan?.billingCycle === 'YEARLY' ? '12 months · rate-locked' : 'Monthly billing' }}</p>
      </div>
      <p class="!m-0 text-[14px] font-semibold text-white">{{ invoice.amount | number:('1.2-2') }} USDT</p>
    </div>

    <ul class="list-none !m-0 p-0 flex flex-col gap-[6px] w-full">
      @if (invoice.userPlan?.userPlanType === 'CORPORATE') {
        <li class="flex items-center gap-[6px]">
          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
<!--          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[]"></mat-icon>-->
          <span class="text-[11px] font-normal text-white">Everything in Pro</span>
        </li>
        <li class="flex items-center gap-[6px]">
          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
          <span class="text-[11px] font-normal text-white">Dedicated compliance team access</span>
        </li>
        @if (invoice.userPlan?.billingCycle === 'YEARLY') {
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">Rates locked for 12 months</span>
          </li>
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">{{ invoice.userPlan?.complianceHoursGranted }} hours of compliance support / year</span>
          </li>
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">Priority hack/theft assistance</span>
          </li>
        }
      } @else {
        <li class="flex items-center gap-[6px]">
          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
          <span class="text-[11px] font-normal text-white">All 4 AML providers · one integration</span>
        </li>
        @if(invoice.userPlan?.complianceHoursGranted){
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">{{ invoice.userPlan?.complianceHoursGranted }} hours of compliance support / year</span>
          </li>
        }
        <li class="flex items-center gap-[6px]">
          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
          <span class="text-[11px] font-normal text-white">Instant Telegram notifications</span>
        </li>
        <li class="flex items-center gap-[6px]">
          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
          <span class="text-[11px] font-normal text-white">Automatic AML reports on deposits/withdrawals</span>
        </li>
        <li class="flex items-center gap-[6px]">
          <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
          <span class="text-[11px] font-normal text-white">Official agreement + API access</span>
        </li>
        @if (invoice.userPlan?.billingCycle === 'YEARLY') {
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">Rates locked for 12 months</span>
          </li>
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">{{ invoice.userPlan?.complianceHoursGranted }} hours of compliance support / year</span>
          </li>
          <li class="flex items-center gap-[6px]">
            <mat-icon svgIcon="check-marker" class="!w-full !h-auto max-w-[8px] max-h-[8px] text-[#218c59]"></mat-icon>
            <span class="text-[11px] font-normal text-white">Dedicated account manager</span>
          </li>
        }
      }
    </ul>

    <div class="h-px w-full bg-white/[0.12]"></div>

    <div class="flex items-center justify-between w-full">
      <span class="text-[14px] font-semibold text-white">Total Due</span>
      <span class="text-[18px] font-bold text-[#66e5b2]">
        {{ (totalDue < 0) ? '0.00' : (totalDue | number:('1.2-2')) }} <span class="text-[#66e5b2] text-[14px] font-semibold">USDT</span>
      </span>
    </div>

    <!-- <button type="button"
            class="w-full py-2 px-3 rounded-lg border border-dashed border-[#bf730f] text-[11px] font-semibold text-[#bf730f] bg-transparent"
            (click)="onSimulatePayment()">
      Demo · simulate payment confirmed →
    </button> -->
  </div>
  <ng-template #qrSvg>
    @if (isGenerating()) {
      Generating QRCode...
    } @else {
      @if (QRCodeUrl(); as url) {
        <!-- Don`t use ngSrc -->
        <img [src]="url" alt="Deposit address qr code" height="113" width="114">
      } @else {
        Ups... Something went wrong
      }
    }
  </ng-template>
}
